module.exports = __webpack_public_path__ + "img/Rectangle34.9f1210d7.png";